export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Tili',
  description: 'Kumppanitilisi tiedot.',
  page: {
    read_only_notice: 'Vain luku. Napsauta Muokkaa muuttaaksesi arvoja.',
    editing_notice: 'Muokataan — muutokset näkyvät tiimillesi ja asiakkaillesi.',
  },
  profile: {
    form: {
      name: {
        label: 'Kumppanin nimi',
        hint: 'Virallinen yrityksen nimi. Käytetään laskutusasiakirjoissa.',
      },
      display_name: {
        label: 'Kuluttajille näkyvä nimi',
        hint: 'Asiakkaillesi kaikissa ravintoloissasi näkyvä "Toteuttaja: ___" -merkintä. Oletuksena kumppanin nimi, jos jätetään tyhjäksi.',
      },
      support_email: {
        label: 'Yhteyssähköposti',
        hint: 'Mistä FoodAmigos ja asiakkaasi tavoittavat sinut. Kirjautumissähköpostisi pysyy muuttumattomana.',
      },
      invoicing_emails: {
        label: 'Laskutussähköpostit',
        hint: 'Sinulle laskutettavien laskujen kuitit lähetetään jokaiseen näistä osoitteista. Jätä tyhjäksi käyttääksesi kirjautumissähköpostiasi.',
        placeholder: 'Kirjautumissähköpostisi',
      },
    },
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  toasts: {
    load_error: 'Tilitietojasi ei voitu ladata.',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
